import type React from 'react'
import { COLORS, RADIUS, FONT } from '../styles/tokens'

/* ── Shared play-screen styles ────────────────────────────────────
 * Used by GamePlayHeader (and available to individual games that
 * need play-screen tokens). Parallel to gameSetupStyles.ts.
 * ──────────────────────────────────────────────────────────────── */
export const gp: Record<string, React.CSSProperties> = {
  // Wrapper that groups header + progress bar
  headerWrap: {
    position:   'sticky' as const,
    top:        0,
    zIndex:     10,
    transition: 'transform 0.25s ease',
  },

  // Sticky gradient header band
  header: {
    background: COLORS.gradientPrimary,
    padding:    '16px 24px',
    display:    'flex',
    alignItems: 'center',
    gap:        16,
  },

  // Back button
  backBtn: {
    fontSize:        '1.4rem',
    color:           'rgba(255,255,255,0.85)',
    padding:         '8px 12px',
    borderRadius:    RADIUS.md,
    background:      'rgba(255,255,255,0.12)',
    border:          'none',
    minWidth:        48,
    minHeight:       48,
    display:         'flex',
    alignItems:      'center',
    justifyContent:  'center',
    cursor:          'pointer',
    flexShrink:      0,
  },

  // Center block — title + optional subtitle
  center: {
    flex:          1,
    display:       'flex',
    flexDirection: 'column' as const,
    gap:           2,
    overflow:      'hidden',
  },

  title: {
    fontFamily:   FONT.family.display,
    fontSize:     FONT.size.xl,
    fontWeight:   700,
    color:        '#FFFFFF',
    lineHeight:   1,
    whiteSpace:   'nowrap' as const,
    overflow:     'hidden',
    textOverflow: 'ellipsis',
  },

  subtitle: {
    fontSize: '0.875rem',
    color:     'rgba(255,255,255,0.65)',
    fontWeight: 600,
    whiteSpace: 'nowrap' as const,
  },

  // Stats pill on the right
  statsCard: {
    display:      'flex',
    alignItems:   'center',
    gap:          12,
    background:   'rgba(255,255,255,0.12)',
    borderRadius: RADIUS.md,
    padding:      '10px 16px',
    flexShrink:   0,
  },

  stat: {
    display:       'flex',
    flexDirection: 'column' as const,
    alignItems:    'center',
    gap:           2,
  },

  statValue: {
    fontFamily: FONT.family.display,
    fontSize:   FONT.size.xl,
    fontWeight: 700,
    color:      '#FFFFFF',
    lineHeight: 1,
  },

  statLabel: {
    fontSize: '0.875rem',
    color:         'rgba(255,255,255,0.6)',
    fontWeight:    700,
    textTransform: 'uppercase' as const,
    letterSpacing: '0.06em',
  },

  statDivider: {
    width:        1,
    height:       28,
    background:   'rgba(255,255,255,0.2)',
    borderRadius: 1,
    flexShrink:   0,
  },

  // Thin progress bar immediately below the header
  progressTrack: {
    height:     5,
    background: 'rgba(27,67,50,0.12)',
    flexShrink: 0,
  },

  progressFill: {
    height:     '100%',
    background: `linear-gradient(90deg, ${COLORS.greenLight}, #D4A017)`,
    borderRadius: '0 4px 4px 0',
    transition: 'width 0.4s ease',
  },
}
